import { pageNames } from '@atc/bonnet-paths';
import { atcBrand, kbbBrand, dealerlistQuery, dealerDetailQuery } from '../constants';
import { getPath, filterDealerQuery } from '.';

const getDealeName = (brand, owner) => {
    const { name: dealerName, franchiseName } = owner;
    return (brand === kbbBrand ? franchiseName : dealerName);
};

export default async (owners = [], isKbb = false, query = {}) => {
    let data = {
        urls: {},
        activeResults: [],
    };

    if (owners) {
        data = await owners.reduce(async (previous, owner) => {
            const acc = await previous;

            // Build Dealer Details urls for each result
            const { dealerId, hasDealerDetail, location } = owner;
            const brand = isKbb ? kbbBrand : atcBrand;

            // remove unwanted parameters from the existing query string
            // eslint-disable-next-line no-unused-vars
            const filteredQuery = filterDealerQuery(query, dealerlistQuery.concat(dealerDetailQuery));

            // Build a path for the dealer details page of this owner
            if (hasDealerDetail && dealerId) {
                delete filteredQuery.zip;
                filteredQuery.state = location?.address?.state || filteredQuery.state;
                filteredQuery.city = location?.address?.city || filteredQuery.city;

                if (isKbb) {
                    delete filteredQuery.make;
                }

                const path = await getPath(pageNames.DEALER_DETAILS, {
                    ...filteredQuery,
                    dealerId,
                    dealerName: getDealeName(brand, owner),
                }, { brand });

                acc.urls[owner.id] = path;
            }

            // push owner to active results
            acc.activeResults.push(owner.id);

            return acc;
        }, Promise.resolve(data));
    }

    return data;
};
